// Recherche texte de la barre — logique pure, testée hors navigateur.

import { comparerFr, etatTemporel } from "./portefeuille";
import type { DateIso, EtatTemporel, Projet } from "./types";

export interface Filtres {
  recherche: string;
  /** Classe de bioagresseur (`adventices`…), ou vide. */
  bioagresseur: string;
  /** Filière, `transversal`, ou vide. */
  filiere: string;
  etat: EtatTemporel | "";
  levier: string;
}

export const FILTRES_VIDES: Readonly<Filtres> = Object.freeze({
  recherche: "",
  bioagresseur: "",
  filiere: "",
  etat: "",
  levier: "",
});

export const VALEUR_TRANSVERSAL = "transversal";

export const filtresActifs = (f: Filtres): boolean =>
  Object.values(f).some((v) => String(v).trim() !== "");

/** Minuscules sans diacritiques : « Châtaigne » se trouve en tapant « chataigne ». */
export function normaliser(texte: string): string {
  return texte
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

function texteIndexe(p: Projet): string {
  return normaliser(
    [
      p.acronyme,
      p.titre,
      p.porteur,
      p.filiere ?? "",
      p.planAction ?? "",
      ...p.bioagresseursCommuns,
      ...p.bioagresseursLatins,
      ...p.cultures.map((c) => c.nom),
    ].join(" "),
  );
}

export function filtrerProjets(projets: Projet[], f: Filtres, aujourdhui: DateIso): Projet[] {
  const termes = normaliser(f.recherche).split(/\s+/).filter(Boolean);
  return projets.filter((p) => {
    if (f.bioagresseur && !p.bioagresseurs.includes(f.bioagresseur)) return false;
    if (f.filiere) {
      const filiere = p.portee === "transversal" ? VALEUR_TRANSVERSAL : p.filiere;
      if (filiere !== f.filiere) return false;
    }
    if (f.etat && etatTemporel(p, aujourdhui) !== f.etat) return false;
    if (f.levier && !p.leviers.includes(f.levier)) return false;
    if (termes.length) {
      const texte = texteIndexe(p);
      if (!termes.every((t) => texte.includes(t))) return false;
    }
    return true;
  });
}

/** Ordre d'affichage par défaut : acronyme, en tri français. */
export const trierParAcronyme = (projets: Projet[]): Projet[] =>
  [...projets].sort((a, b) => comparerFr(a.acronyme, b.acronyme));
